import * as React from "react";
import PopDetail from "../popdetail";
import Wait from "../wait";

export default class ImportPartiesPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            file: null
        }
        this.handleChangeFile = this.handleChangeFile.bind(this)
        this.submit = this.submit.bind(this)
    }

    handleChangeFile = e => {
        this.setState({file: e.target.files[0]})
    }

    submit() {
        if (!this.state.file) {
            alert('Please select a file first')
            return
        }

        const accessToken = sessionStorage.getItem('access');
        if (!accessToken) {
            alert('Please login first')
            return
        }

        try {
            Wait.show('Uploading parties...')
            
            const formData = new FormData()
            formData.append('excel_file', this.state.file)
            formData.append('file', this.state.file) // Also include as 'file' in case API expects it
            formData.append('project_id', this.props.project.id)
            
            console.log('Uploading file:', this.state.file)
            console.log('Project ID:', this.props.project.id)

            fetch('https://nluis.nlupc.go.tz/api/v1/spatial/create/party/bulk', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                },
                body: formData
            })
            .then(async response => {
                Wait.dismiss()
                
                let data;
                try {
                    data = await response.json();
                } catch (e) {
                    throw new Error(`Invalid server response (status ${response.status})`);
                }

                if (!response.ok) {
                    throw new Error(data.message || data.error || `Request failed with status ${response.status}`);
                }

                return data;
            })
            .then(data => {
                console.log('Upload response:', data)
                if (this.props.loadData) {
                    this.props.loadData()
                }
                PopDetail.dismiss()
                alert('Parties imported successfully!')
            })
            .catch(error => {
                Wait.dismiss()
                console.error('Upload error:', error)
                alert('Failed to import parties: ' + (error.message || error))
            })

        } catch (e) {
            Wait.dismiss()
            alert('Error: ' + (e.message || e))
        }
    }

    render() {
        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0}}>

                <table style={{width: '94%', margin: '2%'}}>
                    <tbody>
                    <tr>
                        <td className={'label'} style={{width: '100%'}}>Excel File</td>
                    </tr>
                    <tr>
                        <td>
                            <input 
                                type={'file'} 
                                style={{width: '100%'}} 
                                accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" 
                                name={'file'}
                                onChange={this.handleChangeFile}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{textAlign: 'center', width: '100%', float: 'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Submit
                    </button>
                    <button className={'btn error'} onClick={() => PopDetail.dismiss()}>
                        <span className={'fa fa-times'} style={{padding: 0}}/>Close
                    </button>
                </div>

            </div>

        </div>)
    }
}

